import React, { memo, useMemo } from 'react'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import { SAME, DIFFERENT, FALLBACK_OPTIONS } from 'apps/carrier/constants/insurance'
import { prefixIds } from 'apps/carrier/utils/insurance'

interface IFallbackOptionsProps {
  id: string
  label: string
  value: boolean
  onChange: (...args: any[]) => any
}

const FallbackOptions: React.FunctionComponent<IFallbackOptionsProps> = memo(
  ({ id, label, onChange, value }) => {
    const options = useMemo(() => prefixIds(FALLBACK_OPTIONS, id), [id])
    return (
      <div className='col-xs-12 row no-gutter collapse'>
        <div className='col-xs-12'>
          <RadioGroup
            label={label}
            required={false}
            name={id}
            onOptionChange={onChange}
            checked={value ? SAME : DIFFERENT}
            options={options}
          />
        </div>
      </div>
    )
  }
)
export default FallbackOptions
